import axios from 'axios';

export default {
  getAppVersionsOnTest({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/versionsInStoreOnTest/get`,
        params: ctx,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('insertAppVersionsOnTest', resp.data);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  removeAppVersionOnTest({ commit, state }, platformId) {
    return new Promise((resolve, reject) => {
      commit('removeAppVersionOnTestRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/versionsInStoreOnTest/remove`,
        params: { id: platformId },
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            reject(new Error());
            return;
          }
          commit('removeAppVersionOnTestRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          commit('removeAppVersionOnTestRequestError', err);
          reject(err);
        });
    });
  },
  addAppVersionOnTest({ commit, state }, { appVersionOnTest, event }) {
    return new Promise((resolve, reject) => {
      commit('addAppVersionOnTestRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/versionsInStoreOnTest/add`,
        params: appVersionOnTest,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            event.preventDefault();
            reject(new Error());
            return;
          }
          commit('addAppVersionOnTestRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          event.preventDefault();
          commit('addAppVersionOnTestRequestError', err);
          reject(err);
        });
    });
  },
  editAppVersionOnTest({ commit, state }, { appVersionOnTest, event }) {
    return new Promise((resolve, reject) => {
      commit('editAppVersionOnTestRequestPending');
      axios({
        url: `${state.appConfig.backendUrl}/v1/admin/versionsInStoreOnTest/edit`,
        params: appVersionOnTest,
        method: 'GET'
      })
        .then(resp => {
          if (resp?.data?.result !== true) {
            event.preventDefault();
            reject(new Error());
            return;
          }
          commit('editAppVersionOnTestRequestSuccess');
          resolve(resp);
        })
        .catch(err => {
          event.preventDefault();
          commit('editAppVersionOnTestRequestError', err);
          reject(err);
        });
    });
  }
};
